function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * done
 */
import { createForm } from '@formily/core';
import { ExpressionScope, FormProvider, RecordScope, RecordsScope, RecursionField, SchemaComponentsContext, useField, useFieldSchema, useForm } from '@formily/react';
import { Table as AntdTable, Button, Popconfirm } from 'antd';
import cx from 'classnames';
import { cloneDeep } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { useCssInJs, useDrawerMethod, wrapReactionHook } from "../../hooks";
import { useMount } from "../../internal";
import { genTableEditorStyles, genTableStyles } from "./styles";
import { ScopeContext } from '@micun/form-expression/react/index';
import { Scope } from '@micun/form-expression';
var ColumnEditor = function ColumnEditor(props) {
  var options = props.options,
    schema = props.schema,
    data = props.data,
    context = props.context,
    components = props.components,
    onOk = props.onOk,
    onCancel = props.onCancel;
  var _useDrawerMethod = useDrawerMethod(),
    setOpen = _useDrawerMethod.setOpen,
    render = _useDrawerMethod.render;
  var prefix = 'form-table-editor';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genTableEditorStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var form = useMemo(function () {
    return createForm(_objectSpread(_objectSpread({}, options), {}, {
      values: data
    }));
  }, [data, options]);
  var onClose = function onClose() {
    setOpen(false);
    onCancel();
  };
  var handleOk = function handleOk() {
    form.validate().then(function () {
      setOpen(false);
      onOk(form.values);
    }).catch(function () {});
  };
  var scopeValue = useMemo(function () {
    return {
      JSON: JSON,
      console: console,
      context: context,
      fetch: fetch,
      form: form,
      // wx,
      // Taro,
      React: React
      // ENV,
      // fetch,
    };
  }, [context, form]);
  var scope = useMemo(function () {
    return new Scope({
      context: scopeValue
    });
  }, [scopeValue]);
  return wrapSSR(render(_objectSpread(_objectSpread({}, props), {}, {
    className: cx(prefix, hashId),
    onClose: onClose,
    width: 600,
    footer: /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "-footer")
    }, options.readOnly ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      type: "primary"
    }, "\u786E\u5B9A")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose
    }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
      onClick: handleOk,
      type: "primary"
    }, "\u786E\u5B9A"))),
    children: /*#__PURE__*/React.createElement(FormProvider, {
      form: form
    }, /*#__PURE__*/React.createElement(SchemaComponentsContext.Provider, {
      value: components
    }, /*#__PURE__*/React.createElement(ExpressionScope, {
      value: scopeValue
    }, /*#__PURE__*/React.createElement(ScopeContext.Provider, {
      value: {
        scope: scope
      }
    }, /*#__PURE__*/React.createElement(RecursionField, {
      schema: schema
    })))))
  })));
};
var useColumnEditor = function useColumnEditor() {
  var mount = useMount();
  var components = useContext(SchemaComponentsContext);
  return function (params) {
    return new Promise(function (resolve, reject) {
      mount( /*#__PURE__*/React.createElement(ColumnEditor, _extends({
        components: components,
        onOk: resolve,
        onCancel: reject
      }, params)));
    });
  };
};
export var Table = wrapReactionHook(function (props) {
  var _props$columns = props.columns,
    columns = _props$columns === void 0 ? [] : _props$columns,
    hiddenEditColumn = props.hiddenEditColumn,
    readOnly = props.readOnly,
    originValue = props.value,
    onChange = props.onChange;
  var prefix = 'form-table';
  var value = Array.isArray(originValue) ? originValue : [];
  if (!Array.isArray(value)) {
    console.error('表格数据必须是数组', value);
  }
  var _useCssInJs2 = useCssInJs({
      prefix: prefix,
      styleFun: genTableStyles
    }),
    wrapSSR = _useCssInJs2.wrapSSR,
    hashId = _useCssInJs2.hashId;
  var form = useForm();
  var field = useField();
  var title = field.title;
  var schema = useFieldSchema();
  var editorColumn = useColumnEditor();
  var onEditColumn = function onEditColumn(column, index) {
    console.log('openDrawer', column, index);
    editorColumn({
      title: readOnly ? "".concat(title) : "".concat(column ? '编辑' : '新建').concat(title),
      data: cloneDeep(column) || {},
      context: {
        parentForm: form,
        schema: schema,
        index: index,
        record: column,
        records: value,
        field: field
      },
      schema: schema.items,
      options: {
        readOnly: readOnly
      }
    }).then(function (data) {
      console.log('data', data);
      if (column) {
        var newValue = _toConsumableArray(value);
        newValue[index] = data;
        onChange(newValue);
      } else {
        onChange([].concat(_toConsumableArray(value), [data]));
      }
    }).catch(function (error) {
      console.log('error', error);
    });
  };
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(prefix, hashId)
  }, /*#__PURE__*/React.createElement(RecordsScope, {
    getRecords: function getRecords() {
      return value;
    }
  }, /*#__PURE__*/React.createElement(AntdTable, {
    pagination: false,
    dataSource: value,
    scroll: {
      x: 'max-content'
    },
    bordered: true
  }, columns.map(function (column) {
    return /*#__PURE__*/React.createElement(AntdTable.Column, {
      title: column.title,
      dataIndex: column.dataIndex,
      key: column.key,
      render: function render(text, record, index) {
        if (column.field) {
          return /*#__PURE__*/React.createElement(RecordScope, {
            getRecord: function getRecord() {
              return record;
            },
            getIndex: function getIndex() {
              return index;
            }
          }, /*#__PURE__*/React.createElement(RecursionField, {
            schema: column.field,
            name: [index, column.dataIndex]
          }));
        }
        return text;
      }
    });
  }), columns.length === 0 || hiddenEditColumn ? null : /*#__PURE__*/React.createElement(AntdTable.Column, {
    title: "\u7F16\u8F91",
    width: "130px",
    fixed: "right",
    render: function render(text, record, index) {
      if (readOnly) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx(hashId, 'form-table-column-edit')
        }, /*#__PURE__*/React.createElement(Button, {
          type: "link",
          onClick: function onClick() {
            onEditColumn(record, index);
          }
        }, "\u67E5\u770B"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: cx('form-table-column-edit', hashId)
      }, /*#__PURE__*/React.createElement(Button, {
        type: "link",
        onClick: function onClick() {
          onEditColumn(record, index);
        }
      }, "\u7F16\u8F91"), /*#__PURE__*/React.createElement(Popconfirm, {
        title: "\u786E\u8BA4\u5220\u9664\u5417\uFF1F",
        onConfirm: function onConfirm() {
          var newValue = _toConsumableArray(value);
          newValue.splice(index, 1);
          onChange(newValue);
        }
      }, /*#__PURE__*/React.createElement(Button, {
        danger: true,
        type: "link"
      }, "\u5220\u9664")));
    }
  })), hiddenEditColumn || readOnly ? null : /*#__PURE__*/React.createElement(Button, {
    type: "dashed",
    block: true,
    className: "form-table-button-new",
    onClick: function onClick() {
      onEditColumn();
    }
  }, "\u65B0\u589E\u884C"))));
});